import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../fonts/Futura-PT-Book.ttf";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import styles from "./ForgotID.module.css";
const ForgotID = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [formInput, setFormInput] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    gender: "女性",
  });
  const [email, setEmail] = useState("");
  const changeFormInput = (e) => {
    setFormInput({ ...formInput, [e.target.name]: e.target.value });
  };
  const backToLogin = () => {
    navigate("/login");
  };
  const submit = async () => {
    if (
      formInput.firstname === "" ||
      formInput.lastname === "" ||
      formInput.phone === ""
    ) {
      alert("Please fill out all fields");
      return;
    }
    console.log(formInput);
    const response = await fetch(`${backend_base}/user/forgotid`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        f_name: formInput.firstname,
        l_name: formInput.lastname,
        gender: formInput.gender,
        phone: formInput.phone,
      }),
    });
    const data = await response.json();
    if (response.status === 200 || response.status === 201) {
      console.log("Successfully set the forgot ID");
      console.log(data);
      setEmail(data.Email);
    } else {
      alert("メールアドレス/パスワードエラー");
    }
  };
  return (
    <div>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.container_box}>
          {!email && (
            <>
              <div className={styles.header01}>ログインID確認</div>
              <div className={styles.header_subtext01}>
                ご登録の状況を確認します。
              </div>
              <div className={styles.header_subtext02}>
                下記にご登録情報を入力してください。
              </div>
              <div className={styles.box_bottom_main}>
                <div className={styles.box_bottom_cols}>
                  <div className={styles.box_input1_main}>
                    <div className={styles.input_label}>セイ</div>
                    <input
                      type="text"
                      className={styles.input1}
                      name="firstname"
                      value={formInput.firstname}
                      onChange={changeFormInput}
                    />
                  </div>

                  <div className={styles.box_input2_main}>
                    <div className={styles.box_bottom_header01}>携帯電話</div>
                    <div className={styles.box_bottom_header02}>
                      [ 半角数字 ハイフン不要 ]
                    </div>
                  </div>
                  <div className={styles.box_input3_main}>
                    <input
                      type="text"
                      className={styles.input1}
                      name="phone"
                      value={formInput.phone}
                      onChange={changeFormInput}
                    />
                  </div>
                  <div className={styles.box_input4_main}>
                    <div className={styles.box_input4_text}>性別</div>
                    <div className={styles.radio_section02}>
                      <div className={styles.element0}>
                        <div className={styles.radio_button}>
                          <input
                            className={styles.radio}
                            type="radio"
                            name={"gender"}
                            onClick={(event) => {
                              setFormInput({ ...formInput, gender: "女性" });
                            }}
                            checked={formInput.gender === "女性"}
                          />
                        </div>
                        <div className={styles.radio_text}>女性</div>
                      </div>
                      <div
                        className={styles.element + " " + styles.radio_button_2}
                      >
                        <div className={styles.radio_button}>
                          <input
                            className={styles.radio}
                            type="radio"
                            onClick={(event) => {
                              setFormInput({ ...formInput, gender: "男性" });
                            }}
                            name={"gender"}
                            checked={formInput.gender === "男性"}
                          />
                        </div>
                        <div className={styles.radio_text}>男性</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.box_bottom_cols1}>
                  <div className={styles.box_input1_main}>
                    <div className={styles.input_label}>メイ</div>
                    <input
                      type="text"
                      className={styles.input1}
                      name="lastname"
                      value={formInput.lastname}
                      onChange={changeFormInput}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {email && (
            <>
              <div className={styles.head02}>ログインIDのお知らせ</div>
              <div className={styles.head03}>ご登録の状況をお知らせします</div>
              <div className={styles.head04}>ログインID（メールアドレス）</div>
              <input className={styles.input5} value={email} disabled />
            </>
          )}
        </div>
        <div onClick={email ? backToLogin : submit} className={styles.button1}>
          {email ? "ログイン" : "確認する"}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotID;
